import React from "react";
import { useLocation } from "react-router-dom";
// import components
import BreadcrumbHead from "../../../../Components/BreadcrumbHead/BreadcrumbHead";
import Footer from "../../../../Components/Footer/Footer";
import Navbar from "../../../../Components/Navbar/Navbar";
import Introduction from "../Components/Introduction";

const descriptions = [
  "Introducing No Sugar Company, a trailblazer in creating delectable, sugar-free products. As the first company committed to eliminating sugar from all its offerings, it has revolutionized the market with its delicious keto bars and other innovative sugar-free treats. We have partnered to bring their vision to life, ensuring every product is crafted with 0g of sugar, high-quality, responsibly sourced ingredients, and no additives or fillers. ",
];
const linkText =
  "Embrace a healthier lifestyle with No Sugar Company, where we’re dedicated to supporting your dietary goals with clean, wholesome products.";

function NoSugarProjectDetail() {
  const location = useLocation();
  const { state: project } = location;
  return (
    <>
      <Navbar />
      <BreadcrumbHead title={"The No Sugar"} />
      <Introduction
        src={project.imagePath}
        linkText={linkText}
        linkUrl={project.linkUrl}
        appStoreUrl={project.appStoreUrl}
        googlePlayUrl={project.googlePlayUrl}
        descriptions={descriptions}
      />
      <Footer />
    </>
  );
}

export default NoSugarProjectDetail;
